import Vue from 'vue';
import moment from 'moment';
import 'moment-timezone';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';

const storage = new VuexLocalStorage('_CLIENT_');

export const formatDate = (value: number, format?: string): string => {
  if (!value) return '';

  moment.tz.setDefault(storage.get('timeZone') ?? undefined);
  return moment.unix(value).format(format || 'DD MMM YYYY');
};

export const formatDateTime = (value: number, format?: string): string => {
  if (!value) return '';

  moment.tz.setDefault(storage.get('timeZone') ?? undefined);
  return moment.unix(value).format(format || 'DD MMM YYYY, h:mm A');
};

const filters: { [index: string]: any } = { formatDate, formatDateTime };

Object.keys(filters).forEach((key: string) => {
  Vue.filter(key, filters[key]);
});
